import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  useMediaQuery,
  useTheme
} from "@mui/material";
import Container from "@mui/material/Container";
import CarCard from "../common/CarCard";
import Intro from "../common/Intro";
import "./Home.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [make, setMake] = useState("");
  const [bodyType, setBodyType] = useState("");
  const [budget, setBudget] = useState("");
  const [carData, setCarData] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    fetch("/assets/carData/carData.json")
      .then((res) => res.json())
      .then((data) => setCarData(data))
      .catch((err) => console.error("Failed to fetch car data", err));
  }, []);

  const handleChange = (event, field) => {
    const { value } = event.target;
    if (field === "make") setMake(value);
    if (field === "bodyType") setBodyType(value);
    if (field === "budget") setBudget(value);
  };

  const navigate = useNavigate();

  const handleSubmit = () => {
    const query = new URLSearchParams();
    if (make) query.append("make", make);
    if (bodyType) query.append("bodyType", bodyType);
    if (budget) query.append("budget", budget);
    navigate(`/products?${query.toString()}`);
  };

  return (
    <Box className="home-container">
      <Box
        className="banner"
        sx={{
          height: { xs: "70vh", sm: "90vh", md: "90vh" },
          position: "relative",
          top: { xs: "-70px", sm: "-64px", md: "-64px" },
        }}
      >
        <img
          src={isMobile ? "/assets/banner/mobile.png" : "/assets/banner/banner1.jpg"}
          alt="Luxury Car"
          className="banner-image"
        />
        <Box className="banner-text">
          <Typography variant="h1" sx={{ fontSize: { xs: "2rem", sm: "3rem", md: "4rem" } }}>
            True Choice Cars
          </Typography>
        </Box>

        <Box className="form-container" sx={{ top: { xs: "105%", sm: "105%", md: "90%" } }}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            className="form"
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <InputLabel id="make-label">Make</InputLabel>
                  <Select
                    labelId="make-label"
                    value={make}
                    onChange={(e) => handleChange(e, "make")}
                    label="Make"
                  >
                    <MenuItem value="BMW">BMW</MenuItem>
                    <MenuItem value="Audi">Audi</MenuItem>
                    <MenuItem value="Mercedes">Mercedes</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <InputLabel id="body-type-label">Body Type</InputLabel>
                  <Select
                    labelId="body-type-label"
                    value={bodyType}
                    onChange={(e) => handleChange(e, "bodyType")}
                    label="Body Type"
                  >
                    <MenuItem value="SUV">SUV</MenuItem>
                    <MenuItem value="Sedan">Sedan</MenuItem>
                    <MenuItem value="Coupe">Coupe</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <InputLabel id="budget-label">Budget</InputLabel>
                  <Select
                    labelId="budget-label"
                    value={budget}
                    onChange={(e) => handleChange(e, "budget")}
                    label="Budget"
                  >
                    <MenuItem value="under_1L">Under ₹1,00,000</MenuItem>
                    <MenuItem value="1L_5L">₹1,00,000 - ₹5,00,000</MenuItem>
                    <MenuItem value="above_5L">Above ₹5,00,000</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={3}>
                <Box display="flex" justifyContent="center">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    className="load-more-button"
                    fullWidth
                  >
                    Submit
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>

      <Intro sx={{ mt: { xs: 8, sm: 8 } }} />

      <Container>
        <Box className="recently-added-section">
          <Box className="section-title-container">
            <Typography variant="h4" className="section-title">
              OUR CARS IN STOCK
            </Typography>
            <div className="border-11"></div>
            <div className="border-12"></div>
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              {carData.slice(0, 12).map((car) => (
                <Grid item xs={12} sm={6} md={3} key={car.id}>
                  <CarCard car={car} />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box className="load-more-button-container">
            <Button
              variant="contained"
              className="load-more-button"
              onClick={() => (window.location.href = `/products`)}
            >
              Load More
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Home;
